import React from 'react'
import { Col } from 'reactstrap'
import { Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'

import { cartActions } from '../../redux/slices/cartSlice'
import { formatPrice } from '../../utils/formatPrice'
import '../../styles/product-card.css'

const ProductCard = ({ item }) => {
  const dispatch = useDispatch()

  const addToCart = () => {
    dispatch(cartActions.addItem({ id: item.id, productName: item.productName, price: item.price, imgUrl: item.imgUrl }))
    toast.success(`${item.productName} added to your bag`)
  }

  return (
    <Col lg='3' md='6' className='mb-4'>
      <article className='product__item'>
        <Link className='product__img' to={`/shop/${item.id}`} aria-label={`View ${item.productName}`}>
          <span className='product__badge'>In stock</span>
          <img src={item.imgUrl} alt={item.productName} loading='lazy' decoding='async' width='500' height='500' />
        </Link>
        <div className='product__info'>
          <div className='product__meta'><span>{item.category}</span><span><i className='ri-star-fill'></i> {item.avgRating}</span></div>
          <h3 className='product__name'><Link to={`/shop/${item.id}`}>{item.productName}</Link></h3>
          <div className='product__card-bottom'>
            <span className='price'>{formatPrice(item.price)}</span>
            <button onClick={addToCart} aria-label={`Add ${item.productName} to cart`}>
              <i className='ri-add-line'></i>
            </button>
          </div>
        </div>
      </article>
    </Col>
  )
}

export default ProductCard
